<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import { debounce } from '$lib/utils/debounce';
	import Bubble from './Bubble.svelte';
	import Comment from './Comment.svelte';
	import reviewsJSON from './reviews.json';

	let { backgroundColor = 'grey', reviews = reviewsJSON, id = '' } = $props();

	let reviewsFiltered = reviews?.reviews;

	// On mobile, we want to wait for the finger release or
	// the page will jump around
	let isTouching = false;

	// If they are mid-drag (mouse)
	let isDragging = false; //? Consider $state(false) later for !cursor-grabbing?

	// when using the svelte onscroll directive the event was not being removed properly,
	// so i'm just adding it within the use: directive instead

	function setupScrollListener(el) {
		el.addEventListener('scroll', scrollListener);
		window.addEventListener('touchstart', () => (isTouching = true));
		window.addEventListener('touchend', () => (isTouching = false));

		let startX;
		let scrollLeft;

		const onMouseDown = (e) => {
			isDragging = true;
			startX = e.pageX - el.offsetLeft;
			scrollLeft = el.scrollLeft;
			el.classList.add('!cursor-grabbing');
		};

		const onMouseMove = (e) => {
			if (!isDragging) return;
			e.preventDefault();
			const x = e.pageX - el.offsetLeft;
			const walk = (x - startX) * 1.5; // Adjust scroll speed
			el.scrollLeft = scrollLeft - walk;
		};

		const onMouseUp = () => {
			isDragging = false;
			el.classList.remove('!cursor-grabbing');
		};

		el.addEventListener('mousedown', onMouseDown);
		el.addEventListener('mousemove', onMouseMove);
		el.addEventListener('mouseleave', onMouseUp);
		el.addEventListener('mouseup', onMouseUp);
	}

	const handleScrollStop = debounce((target) => {
		if (!isTouching) {
			collapseExpandedComments(target);
		}
	}, 150);

	function scrollListener(event) {
		handleScrollStop(event.target);
	}
	function collapseExpandedComments(el) {
		el.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
			input.checked = false;
		});
	}
</script>

<Section backgroundColor="grey-dark" {id}>
	<h2 class="text-indow-white">Trusted Since 2010</h2>
	<p class="max-w-160">
		Indow has insulated more than 23,000 buildings - helping reduce carbon
		emissions by nearly 200,000 tons - and creating comfort across the US &
		Canada!
	</p>
</Section>
<Section {backgroundColor}>
	<h2 class="sr-only relative">Reviews</h2>
	<div class="!col-span-full w-full">
		<Bubble
			title="Excellent"
			rating={reviews?.stats?.company?.average_rating}
			average={reviews?.stats?.company?.average_rating}
			total={reviews?.stats?.company?.review_count}
		/>

		<ul
			use:setupScrollListener
			class="scrollbar-force-hide
				flex w-full
				cursor-move
				snap-x
				snap-mandatory list-none
				flex-row overflow-x-auto
				overflow-y-hidden overscroll-x-none scroll-smooth select-none"
		>
			{#each reviewsFiltered as review (review.id)}
				<li
					itemscope
					itemtype="https://schema.org/Review"
					class="md:max-width-auto relative w-full max-w-[80%] flex-none snap-start pr-3 pl-3 md:w-[300px]"
				>
					<div
						itemprop="itemReviewed"
						itemscope
						itemtype="https://schema.org/Organization"
					>
						<meta itemprop="name" content="Indow" />
						<link itemprop="url" href="https://indowwindows.com" />
					</div>
					<Comment
						name={review?.author?.name}
						body={review?.comments}
						rating={review?.rating}
						date={review?.date_created}
						timeAgo={review?.time_ago}
					/>
				</li>
			{/each}
		</ul>
	</div>
</Section>

<style>
	.scrollbar-force-hide {
		scrollbar-width: none; /* Firefox */
		-ms-overflow-style: none; /* IE & Edge */
	}

	.scrollbar-force-hide::-webkit-scrollbar {
		display: none;
	}
</style>
